import React from 'react'
import TextField from '@mui/material/TextField'

export default function PasswordField({
  label = "password",
  autoComplete = "email",
  margin = "normal",
  fullWidth = true,
  name = "password",
  type = "password",
  value = '',
  onChange,
  ...props
}){
  return <TextField {...{
    ...props,
    label,
    autoComplete,
    margin,
    fullWidth,
    name,
    type,
    value: value || '',
    onChange: React.useMemo(
      () => (
        onChange
          ? event => onChange(event.target.value, event)
          : null
      ),
      [onChange]
    ),
  }}/>
}
